import axios from '../../index'
import qs from 'qs'
/**
 * @description 加载管理中心-采购商(收藏，积分，采购历史，优惠券))
 * @author hd
 * @date 2020-03-06
 * @export
 *
 */

export function loadManage (params) {
  return axios.post(`/user/user-center`, qs.stringify(params))
}


/**
 * @description 加载管理中心（用户身份信息）
 * @author hd
 * @date 2020-03-06
 * @export
 *
 */
export function loadInformation (params) {
  return axios.post(`/user/load-index`, qs.stringify(params))
}
